import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { isError } from 'lodash';
import { connect } from 'react-redux';
import { Map } from 'immutable';
import classNames from 'classnames';
import { Alert, Modal, Form, FormGroup } from 'react-bootstrap';
import { hideWorkspaceEmailDialog } from '../../actions/mainUI';
import { emailUMOsViaLightbox, emailUMOsViaLightboxDismiss, workspacePushToDMZ, portalShareToDMZ } from '../../actions/umoUtils';
import Button from '../ui/Button';
import Loader from '../ui/Loader';

const mapStateToProps = state => ({
  umoUtils: state.umoUtils,
});

const mapDispatchToProps = dispatch => ({
  onEmailSubmit: (workspaceID, fromName, fromEmail, toEmail, message, isPortal) =>
    dispatch(emailUMOsViaLightbox(workspaceID, fromName, fromEmail, toEmail, message, isPortal)),
  onWSPushToDMZ: wsID => dispatch(workspacePushToDMZ(wsID)),
  onPortalShareToDMZ: (wsID, fromName, fromEmail, toEmail, message, isPortal) =>
    dispatch(portalShareToDMZ(wsID, fromName, fromEmail, toEmail, message, isPortal)),
  onEmailDismiss: () =>
    dispatch(emailUMOsViaLightboxDismiss()),
  hideWorkspaceEmailDialog: () =>
    dispatch(hideWorkspaceEmailDialog()),
});

class WorkspaceEmailDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isSubmitting: false,
      isValid: false,
      error: null,
      isSuccess: false,
      fromName: '',
      toEmail: '',
      message: '',
      isPortal: false,
      isDMZPortal: false,
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);
    this.onExited = this.onExited.bind(this);
    this.onCloseClick = this.onCloseClick.bind(this);
    this.updateField = this.updateField.bind(this);
  }

  componentDidUpdate(prevProps) {
    const emailRequestData = this.props.umoUtils.get('emailRequests');
    if (emailRequestData !== prevProps.umoUtils.get('emailRequests')) {
      const errMsg = isError(emailRequestData);
      // if success- close dialog
      if (!errMsg && !Map.isMap(emailRequestData)) {
        this.props.hideWorkspaceEmailDialog();
      } else {
        this.setState({
          isSubmitting: !!Map.isMap(emailRequestData),
          isValid: false,
          error: errMsg ? emailRequestData : null,
          isSuccess: (!Map.isMap(emailRequestData) && !errMsg && emailRequestData), // on success)
        });
      }
    }
    if (this.props.selectedWorkspaceData !== prevProps.selectedWorkspaceData) {
      this.setState({
        isSubmitting: !!Map.isMap(emailRequestData), // started sending
        isValid: false,
        error: isError(emailRequestData) ? emailRequestData : null, // on error
        isSuccess: (!Map.isMap(emailRequestData) &&
          !isError(emailRequestData) && emailRequestData), // on success
        fromName: '',
        toEmail: '',
        message: '',
        isPortal: this.props.selectedWorkspaceData ?
          this.props.selectedWorkspaceData.isPortal : false,
        isDMZPortal: this.props.selectedWorkspaceData ?
          this.props.selectedWorkspaceData.isDMZPortal : false,
      });
    }
  }

  onCloseClick() {
    if (!this.state.isSubmitting) {
      this.props.hideWorkspaceEmailDialog();
    }
  }

  onFormSubmit(e) {
    e.preventDefault();
    if (this.state.isDMZPortal) {
      this.props.onWSPushToDMZ(this.props.selectedWorkspaceData.id)
    .then((res) => {
      if (isError(res)) {
        this.setState({ error: res.message });
      } else {
        this.props.onPortalShareToDMZ(this.props.selectedWorkspaceData.id,
          this.state.fromName,
          undefined,
          this.state.toEmail,
          this.state.message,
          this.state.isPortal,
          this.state.isDMZPortal)
          .then((pushRes) => {
            if (pushRes && (pushRes.success ||
              (pushRes.a && pushRes.a.SUCCESS && pushRes.a.SUCCESS[0]))) {
              this.onCloseClick();
            } else {
              this.setState({ error: res.message || this.props.intl.formatMessage({ id: 'general.error' }) });
            }
          })
          .catch(err => this.setState({ error: err.message || this.props.intl.formatMessage({ id: 'general.error' }) }));
      }
    })
    } else {
      this.props.onEmailSubmit(
        this.props.selectedWorkspaceData.id,
        this.state.fromName,
        undefined,
        this.state.toEmail,
        this.state.message,
        this.state.isPortal,
        false,
      )
        .then((res) => {
          if (res && res.success) {
            this.onCloseClick();
          } else {
            this.setState({ error: res.message || this.props.intl.formatMessage({ id: 'general.error' }) });
          }
        });
    }
  }

  onExited() {
    if (this.props.onDialogClose) this.props.onDialogClose();
    this.props.onEmailDismiss();
  }

  updateField(newData) {
    const fieldsState = {
      fromName: this.state.fromName,
      toEmail: this.state.toEmail,
      message: this.state.message,
      ...newData,
    };

    fieldsState.isValid = fieldsState.fromName.length > 0 && fieldsState.toEmail.length > 0;

    this.setState(fieldsState);
  }

  render() {
    const { intl } = this.props;
    let message;

    if (this.state.error) {
      message = (
        <Alert variant="danger" onDismiss={this.props.onEmailDismiss}>
          {this.state.error}
        </Alert>
      );
    } else if (this.state.isSuccess) {
      message = (
        <Alert variant="success" onDismiss={this.props.onEmailDismiss}>
          {intl.formatMessage({ id: 'workspaceEmailDialog.emailSentSuccessMessage' })}
        </Alert>
      );
    }
    const titleID = this.state.isPortal ? 'searchResults.options.actions.shareAsPortal' : 'workspaceEmailDialog.emailWorkspaceHeader';

    return (
      <div className="workspace-dialog">
        <Modal
          show={this.props.isShown}
          onHide={this.props.hideWorkspaceEmailDialog}
          onExited={this.onExited}
          backdrop={this.state.isSubmitting ? 'static' : true}
          dialogClassName={classNames('workspace-dialog__overlay')}
        >
          <span
            onClick={this.onCloseClick}
            className="workspace-dialog__close-button"
          />

          <div className="workspace-dialog__form">
            <div className="workspace-dialog__form-header">
              {intl.formatMessage({ id: titleID })}

              <div className="workspace-dialog__form-header-sub">
                {this.state.isPortal ?
                  intl.formatMessage({ id: 'workspaceEmailDialog.emailWorkspacePortal' })
                  : intl.formatMessage({ id: 'workspaceEmailDialog.emailWorkspaceSubtext' })
                }
              </div>
            </div>

            <Form onSubmit={this.onFormSubmit} className="form">
              <div className="form-group">
                <Form.Control
                  type="text"
                  disabled={this.state.isSubmitting}
                  placeholder={this.state.isPortal ?
                    intl.formatMessage({ id: 'workspaceEmailDialog.accountNamePlaceholder' })
                    : intl.formatMessage({ id: 'workspaceEmailDialog.namePlaceholder' })}
                  onChange={(e) => { this.updateField({ fromName: e.target.value }); }}
                  value={this.state.fromName}
                />
              </div>

              <div className="form-group">
                <Form.Control
                  as="textarea"
                  disabled={this.state.isSubmitting}
                  placeholder={intl.formatMessage({ id: 'workspaceEmailDialog.toEmailPlaceholder' })}
                  onChange={(e) => { this.updateField({ toEmail: e.target.value }); }}
                  value={this.state.toEmail}
                />
                {this.state.isPortal ? null :
                <Form.Control.Feedback>{intl.formatMessage({ id: 'workspaceEmailDialog.toEmailSubtext' })}</Form.Control.Feedback>}
              </div>
              <div className="form-group">
                <Form.Control
                  disabled={this.state.isSubmitting}
                  as="textarea"
                  placeholder={intl.formatMessage({ id: 'workspaceEmailDialog.messagePlaceholder' })}
                  onChange={(e) => { this.updateField({ message: e.target.value }); }}
                  value={this.state.message}
                />
              </div>
              {message}
              {this.state.isDMZPortal ?
                <span className="form-text text-muted workspace-dialog__help-msg">
                  {intl.formatMessage({ id: 'workspaceEmailDialog.DMZMessage' })}
                </span>
                : null }
              <Modal.Footer>
                <Button disabled={this.state.isSubmitting} onClick={this.onCloseClick}>
                  {intl.formatMessage({ id: 'workspaceEmailDialog.cancelButton' })}
                </Button>

                <Button
                  primary type="submit"
                  disabled={this.state.isSubmitting || !this.state.isValid}
                >
                  {
                    this.state.isSubmitting ? <Loader /> :
                      intl.formatMessage({ id: 'workspaceEmailDialog.sendButton' })
                  }
                </Button>
              </Modal.Footer>
            </Form>
          </div>
        </Modal>
      </div>
    );
  }
}

WorkspaceEmailDialog.propTypes = {
  isShown: PropTypes.bool,
  onDialogClose: PropTypes.func,
  onEmailSubmit: PropTypes.func,
  onWSPushToDMZ: PropTypes.func,
  onPortalShareToDMZ: PropTypes.func,
  onEmailDismiss: PropTypes.func,
  hideWorkspaceEmailDialog: PropTypes.func,
  umoUtils: PropTypes.instanceOf(Map),
  selectedWorkspaceData: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    description: PropTypes.string,
    isPortal: PropTypes.bool,
  }),
};

export default injectIntl(connect(mapStateToProps, mapDispatchToProps)(WorkspaceEmailDialog));
